import React, { createContext, useContext, useState, useEffect } from 'react'
import SessionExpiredModal from 'src/components/application/SessionExpiredModal';
import { registerShowSessionExpiredModal } from 'src/services/sessionExpired';
const SessionExpiredModalContext = createContext()

export function SessionExpiredModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  useEffect(() => {
    registerShowSessionExpiredModal(show);
  }, []);

  return (
    <SessionExpiredModalContext.Provider value={{ showSessionExpiredModal: show }}>
      {children}
      <SessionExpiredModal open={open} onClose={hide} />
    </SessionExpiredModalContext.Provider>
  )
}

export function useSessionExpiredModal() {
  const ctx = useContext(SessionExpiredModalContext);
  if (!ctx) throw new Error('useSessionExpiredModal deve ser usado dentro de SessionExpiredModalProvider');
  return ctx;
}
